import React, { cloneElement } from 'react';
import { Page, PageHeader, PanelContainer } from '../page-framework';
import ActionLinearProgress from '../linear-progress/ActionLinearProgress';

export default function AdminPage({
    pageId,
    title,
    breadcrumbs,
    actions,
    children,
    filterElement,
    disablePanelPropsInjection,
    isActioning = false,
}) {
    return (
        <Page id={pageId} isAdminPage>
            <PageHeader breadcrumbs={breadcrumbs} title={title} actions={actions}>
                {filterElement}
            </PageHeader>
            <ActionLinearProgress isActioning={isActioning} />
            <PanelContainer optimizeLayoutUpdates={false}>
                {disablePanelPropsInjection
                    ? children
                    : cloneElement(children, {
                          hideTitle: true,
                          flexHeight: true,
                      })}
            </PanelContainer>
        </Page>
    );
}
